import { formatDate } from "@angular/common";
import { Component, ElementRef, QueryList, ViewChildren } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, FormArray, Validators, } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { PlacePickerComponent } from "src/app/place-picker/place-picker.component";
import { ApiService } from "src/app/shared/services/api.service";
import { ToastrMsgService } from "src/app/shared/services/shared-services/toastr.service";

@Component({
  selector: 'app-add-design-stage',
  templateUrl: './add-design-stage.component.html',
  styleUrl: './add-design-stage.component.css'
})
export class AddDesignStageComponent {
  projectId: any;
  rolesList: [] = [];
  locationForm: FormGroup;
  clientForm: FormGroup;
  availableStates: any[] = [];
  availableCities: any[] = [];
  designProjectForm: FormGroup;

  submitted = false;
  statusList = [
    { id: 1, status: "Pre-feasibility" },
    { id: 2, status: "Feasibility" },
    { id: 3, status: "Detailed Project Report (DPR)" },
    { id: 4, status: "Tendering" },
    { id: 5, status: "Construction" },
    { id: 6, status: "Maintenance" },
    { id: 7, status: "Handover" },
  ];
  statusList_ = [
    { id: "1", status: "Pre-Planning" },
    { id: "2", status: "Planning" },
    { id: "3", status: "Survey" },
    { id: "4", status: "Design Revisions & Scope Adjustments" },
    { id: "5", status: "ConsExecutiontruction" },
    { id: "6", status: "Closure" },
  ];
  staffList: any[] = [];
  currentDate = new Date();
  selectedFile: string = '';
  searchKeyword = "";
  userData: any
  userDataM: any
  cValue = formatDate(this.currentDate, "yyyy-MM-dd", "en-US");
  selectedFileName: string = '';
  acceptedFileTypes = '.pdf,.doc,.docx,.png,.jpg'; // customize if needed
  @ViewChildren('fileInput') fileInputs!: QueryList<ElementRef<HTMLInputElement>>;
  allState: any
  allDistricts: any
  allSubDistricts: any
  allVillage: any;
  organizationId: any;
  userD: any;
  branchList: any
  branchShow = true;
  selectedDomain = '';
  domainOptions:any = [];
  domainFields: { [key: string]: any[] } = {
    Residential: [
      { key: 'floor_plan_configuration', label: 'Floor Plan Configuration', type: 'text', value: '2BHK, 3BHK' },
      { key: 'balcony_area', label: 'Balcony Area', type: 'text', value: '120 sq ft' },
      { key: 'ventilation_strategy', label: 'Ventilation Strategy', type: 'text', value: 'Cross-ventilation' },
    ],
    Commercial: [
      { key: 'facade_design', label: 'Façade Design', type: 'text', value: 'Glass curtain wall' },
      { key: 'hvac_layout', label: 'HVAC Layout', type: 'text', value: 'Centralized duct system' },
      { key: 'emergency_exit_plan', label: 'Emergency Exit Plan', type: 'text', value: '2 exits per floor' },
    ],
    Educational: [
      { key: 'classroom_dimensions', label: 'Classroom Dimensions', type: 'text', value: '600 sq ft' },
      { key: 'auditorium_design', label: 'Auditorium Design', type: 'text', value: '500 seats' },
      { key: 'lab_safety_layout', label: 'Lab Safety Layout', type: 'text', value: 'Fume hoods, eyewash' },
    ],
    Water: [
      { key: 'treatment_plant_layout', label: 'Treatment Plant Layout', type: 'text', value: 'Sequential tanks' },
      { key: 'pipe_diameter', label: 'Pipe Diameter', type: 'text', value: '300 mm' },
      { key: 'chlorination_chamber', label: 'Chlorination Chamber', type: 'text', value: '10,000 liters' },
    ],
    Power: [
      { key: 'switchgear_layout', label: 'Switchgear Layout', type: 'text', value: 'Ring Main Unit' },
      { key: 'cable_trench_width', label: 'Cable Trench Width', type: 'text', value: '1 meter' },
      { key: 'transformer_housing', label: 'Transformer Housing', type: 'text', value: 'Outdoor kiosk' },
    ],
    Gas: [
      { key: 'pipeline_diameter', label: 'Pipeline Diameter', type: 'text', value: '150 mm' },
      { key: 'pressure_regulation_box', label: 'Pressure Regulation Box', type: 'text', value: 'Dual-stage regulator' },
      { key: 'safety_valve_placement', label: 'Safety Valve Placement', type: 'text', value: 'Every 500 meters' },
    ],
    Telecom: [
      { key: 'tower_structural_design', label: 'Tower Structural Design', type: 'text', value: 'Lattice tower' },
      { key: 'antenna_mounting_height', label: 'Antenna Mounting Height', type: 'text', value: '45 meters' },
      { key: 'cable_tray_layout', label: 'Cable Tray Layout', type: 'text', value: 'Overhead + underground' },
    ],
    Road: [
      { key: 'pavement_layering', label: 'Pavement Layering', type: 'text', value: 'Subgrade, Base, Asphalt' },
      { key: 'median_width', label: 'Median Width', type: 'text', value: '2 meters' },
      { key: 'signage_placement_plan', label: 'Signage Placement Plan', type: 'text', value: 'Every 500 meters' },
    ],
    Consultancy: [
      { key: 'design_review_checklist', label: 'Design Review Checklist', type: 'text', value: 'Structural, MEP, Safety' },
      { key: 'client_feedback_log', label: 'Client Feedback Log', type: 'text', value: 'Weekly comments' },
      { key: 'revision_history', label: 'Revision History', type: 'text', value: 'V1.0, V1.1, V2.0' },
    ]
  };
  proShow = true
  projectList: any
  constructor(
    private fb: FormBuilder,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private router: Router, private route: ActivatedRoute, private dialog: MatDialog
  ) {

  }
  triggerFileInput(index: number): void {
    const inputsArray = this.fileInputs?.toArray();
    if (inputsArray && inputsArray[index]) {
      inputsArray[index].nativeElement.click();
    }
  }
  ngOnInit(): void {
    const user = localStorage.getItem('user') as any;
    this.userD = JSON.parse(user);
    this.organizationId = this.userD.user.org_id;
    this.fetchBranchList()
    this.route.params.subscribe((params) => {
      this.projectId = params['id'];

    });
    if (this.projectId) {
      this.proShow = false
      this.getProjectDetails();
    }
    this.designProjectForm = this.formBuilder.group({
      company_name: [this.userD.user.org_name, Validators.required],
      company_id: [this.userD.user.org_id, Validators.required],
      company_code: [this.userD.user.company_code, Validators.required],
      project_name: ["", Validators.required],
      project_id: ["", Validators.required],
      branch_id: [+this.organizationId, Validators.required],
      design_lead: ["", Validators.required],
      design_start_date: ["", Validators.required],
      design_end_date: ["", Validators.required],
      design_software_used: ["", Validators.required],
      drawing_reference_code: ["", Validators.required],
      structural_design_type: ["", Validators.required],
      safety_standards: ["", Validators.required],
      design_approval_status: ["", Validators.required],
      domain: ["", Validators.required],
      stage: ['Designstage']

    });
    this.locationForm = this.formBuilder.group({
      location: this.formBuilder.array([this.createLocationGroup()])
    });
    this.availableStates[0] = [];
    this.availableCities[0] = [];


    this.clientForm = this.formBuilder.group({
      client_name: ["", Validators.required],
      contact_person: ["", Validators.required],
      contact_number: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      khasra_no: ["", Validators.required],
      area: ["", Validators.required],
      state: ["", Validators.required],
      district: ["", Validators.required],
      subDistrict: ["", Validators.required],
      villages: ["", Validators.required],
      client_id: [""],

    });

    this.getstates();
    this.fetchDataPreProject()
  }
  fetchDataPreProject() {
    const params = { keyword: this.searchKeyword ? this.searchKeyword : "" };
    this.apiService.getProject(params).subscribe({
      next: (res: any) => {
        this.projectList = res;
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }
  onDomainChange(domain: string) {
    this.selectedDomain = domain;

    Object.keys(this.designProjectForm.controls).forEach(key => {
      if (key !== 'domain' && this.domainFields[domain]?.find(field => field.key === key) === undefined &&
        Object.values(this.domainFields).flat().some(field => field.key === key)) {
        this.designProjectForm.removeControl(key);
      }
    });

    this.domainFields[domain].forEach(field => {
      this.designProjectForm.addControl(field.key, this.fb.control(field.value));
    });
  }
  fetchBranchList() {
    this.apiService.getOrganizationsBranch(this.organizationId).subscribe({
      next: (res: any) => {
        if (res.data.length != 0) {

          this.branchList = res.data
        } else {

          this.branchShow = false
          this.designProjectForm.get('owner')?.setValue(this.userD.user.org_name);
        }


      },
      error: (err) => {
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => '',
    });
  }

  onBranchChange(selectedBranchId: any) {

    const selectedBranch = this.branchList.find((b: { branch_id: any; }) => b.branch_id === selectedBranchId);
    const manager = selectedBranch?.primary_contact_name || '';
    this.designProjectForm.get('design_lead')?.setValue(manager);
  }




  // Getter for easy access
  get location() {
    return this.locationForm.get('location') as FormArray;
  }



  // Create one contact group
  createLocationGroup(): FormGroup {
    return this.formBuilder.group({
      lat: ['', Validators.required],
      long: ['', Validators.required,],
      city: ['', Validators.required,],
      state: ['', Validators.required],
      country: ['', Validators.required],
      pincode: ['', Validators.required],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],
    });
  }

  // Add new contact
  addBranch() {
    this.location.push(this.createLocationGroup());
    // Also prepare arrays for new index
    const index = this.location.length - 1;
    this.availableStates[index] = [];
    this.availableCities[index] = [];
  }

  // Remove contact at index
  removeBranch(index: number) {
    if (this.location.length > 1) {
      this.location.removeAt(index);
    }
    this.availableStates.splice(index, 1);
    this.availableCities.splice(index, 1);
  }

  onProjectChange(selectedBranchId: any) {
    this.apiService.getProjectId(selectedBranchId).subscribe({
      next: (res: any) => {
        this.designProjectForm.patchValue({
          project_name: res.project_name ?? '',
          branch_id: res.branch_id ?? '',
          design_start_date: res.design_start_date ? new Date(res.design_start_date) : '',
          design_end_date: res.design_end_date ? new Date(res.design_end_date) : '',
          design_software_used: res.design_software_used ?? '',
          design_lead: res.design_lead ?? '',
          drawing_reference_code: res.drawing_reference_code ?? '',
          metadata: res.metadata ?? '',
          owner_id: res.owner_id ?? '',
          domain: res.domain ?? '',
          structural_design_type: res.structural_design_type ?? '',
          safety_standards: res.safety_standards ?? '',
          design_approval_status: res.design_approval_status ?? '',

          // Residential
          floor_plan_configuration: res.floor_plan_configuration ?? '',
          balcony_area: res.balcony_area ?? '',
          ventilation_strategy: res.ventilation_strategy ?? '',

          // Commercial
          facade_design: res.facade_design ?? '',
          hvac_layout: res.hvac_layout ?? '',
          emergency_exit_plan: res.emergency_exit_plan ?? '',

          // Educational
          classroom_dimensions: res.classroom_dimensions ?? '',
          auditorium_design: res.auditorium_design ?? '',
          lab_safety_layout: res.lab_safety_layout ?? '',

          // Water
          treatment_plant_layout: res.treatment_plant_layout ?? '',
          pipe_diameter: res.pipe_diameter ?? '',
          chlorination_chamber: res.chlorination_chamber ?? '',

          // Power
          switchgear_layout: res.switchgear_layout ?? '',
          cable_trench_width: res.cable_trench_width ?? '',
          transformer_housing: res.transformer_housing ?? '',

          // Gas
          pipeline_diameter: res.pipeline_diameter ?? '',
          pressure_regulation_box: res.pressure_regulation_box ?? '',
          safety_valve_placement: res.safety_valve_placement ?? '',

          // Telecom
          tower_structural_design: res.tower_structural_design ?? '',
          antenna_mounting_height: res.antenna_mounting_height ?? '',
          cable_tray_layout: res.cable_tray_layout ?? '',

          // Road
          pavement_layering: res.pavement_layering ?? '',
          median_width: res.median_width ?? '',
          signage_placement_plan: res.signage_placement_plan ?? '',

          // Consultancy
          design_review_checklist: res.design_review_checklist ?? '',
          client_feedback_log: res.client_feedback_log ?? '',
          revision_history: res.revision_history ?? '',
        });

        this.clientForm.patchValue(res);


        const lData = res?.location || [];
        const branchFormArray = this.location;
        branchFormArray.clear();


        lData.forEach((loc: {
          address_line_2: string;
          address_line_1: string; country: any; state: any; city: any; lat: any; long: any; pincode: any; officename: any;
        }, index: number) => {
          const branchGroup = this.createLocationGroup();
          this.location.push(branchGroup);

          // Step 1: Patch country and trigger state dropdown
          branchGroup.patchValue({ country: loc.country || '' });
          this.onCountryBChange(index); // load states for this country

          // Step 2: Wait a bit to ensure states are loaded, then patch state and trigger cities
          setTimeout(() => {
            branchGroup.patchValue({ state: loc.state || '' });
            this.onStateBChange(index); // load cities for this state

            // Step 3: Patch remaining fields
            branchGroup.patchValue({
              city: loc.city || '',
              lat: loc.lat || '',
              long: loc.long || '',
              pincode: loc.pincode || '',
              officename: loc.officename || '',
              address_line_1: loc.address_line_1 || '',
              address_line_2: loc.address_line_2 || '',
            });
          }, 200); // delay to allow API call for states to finish
        });

        // If empty:
        if (branchFormArray.length === 0) {
          branchFormArray.push(this.createLocationGroup());
        }

        this.onDomainChange(this.designProjectForm.value.domain)
           this.domainFields[this.designProjectForm.value.domain].forEach(field => {
          if (res.hasOwnProperty(field.key)) {
            this.designProjectForm.get(field.key)?.patchValue(res[field.key]);
          }
        });

        this.getdistricts()
        this.getsubdistricts()
        this.getvillages()



      },
      error: (err) => {

        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });

  }

  getProjectDetails() {
    this.apiService.getDesignStageById(this.projectId).subscribe({
      next: (res: any) => {
        this.designProjectForm.patchValue({
          project_name: res.project_name ?? '',
          branch_id: res.branch_id ?? '',
          project_id: res.id ?? '',
          design_start_date: res.design_start_date ? new Date(res.design_start_date) : '',
          design_end_date: res.design_end_date ? new Date(res.design_end_date) : '',
          design_software_used: res.design_software_used ?? '',
          design_lead: res.design_lead ?? '',
          drawing_reference_code: res.drawing_reference_code ?? '',
          metadata: res.metadata ?? '',
          owner_id: res.owner_id ?? '',
          domain: res.domain ?? '',
          structural_design_type: res.structural_design_type ?? '',
          safety_standards: res.safety_standards ?? '',
          design_approval_status: res.design_approval_status ?? '',

          // Residential
          floor_plan_configuration: res.floor_plan_configuration ?? '',
          balcony_area: res.balcony_area ?? '',
          ventilation_strategy: res.ventilation_strategy ?? '',

          // Commercial
          facade_design: res.facade_design ?? '',
          hvac_layout: res.hvac_layout ?? '',
          emergency_exit_plan: res.emergency_exit_plan ?? '',

          // Educational
          classroom_dimensions: res.classroom_dimensions ?? '',
          auditorium_design: res.auditorium_design ?? '',
          lab_safety_layout: res.lab_safety_layout ?? '',

          // Water
          treatment_plant_layout: res.treatment_plant_layout ?? '',
          pipe_diameter: res.pipe_diameter ?? '',
          chlorination_chamber: res.chlorination_chamber ?? '',

          // Power
          switchgear_layout: res.switchgear_layout ?? '',
          cable_trench_width: res.cable_trench_width ?? '',
          transformer_housing: res.transformer_housing ?? '',

          // Gas
          pipeline_diameter: res.pipeline_diameter ?? '',
          pressure_regulation_box: res.pressure_regulation_box ?? '',
          safety_valve_placement: res.safety_valve_placement ?? '',

          // Telecom
          tower_structural_design: res.tower_structural_design ?? '',
          antenna_mounting_height: res.antenna_mounting_height ?? '',
          cable_tray_layout: res.cable_tray_layout ?? '',

          // Road
          pavement_layering: res.pavement_layering ?? '',
          median_width: res.median_width ?? '',
          signage_placement_plan: res.signage_placement_plan ?? '',

          // Consultancy
          design_review_checklist: res.design_review_checklist ?? '',
          client_feedback_log: res.client_feedback_log ?? '',
          revision_history: res.revision_history ?? '',
        });
        this.onDomainChange(this.designProjectForm.value.domain)
         this.domainFields[this.designProjectForm.value.domain].forEach(field => {
          if (res.hasOwnProperty(field.key)) {
            this.designProjectForm.get(field.key)?.patchValue(res[field.key]);
          }
        });
        const client = res
        this.clientForm.patchValue({
          client_name: client.client_name,
          contact_person: client.contact_person,
          contact_number: client.contact_number,
          state: client.state,
          district: client.district,
          sub_district: client.sub_district,
          villages: client.villages,
          khasra_no: client.khasra_no,
          area: client.area,
          client_id: client.client_id

        });


        const lData = res?.location || [];
        const branchFormArray = this.location;
        branchFormArray.clear();


        lData.forEach((loc: {
          address_line_2: string;
          address_line_1: string; country: any; state: any; city: any; lat: any; long: any; pincode: any; officename: any;
        }, index: number) => {
          const branchGroup = this.createLocationGroup();
          this.location.push(branchGroup);

          // Step 1: Patch country and trigger state dropdown
          branchGroup.patchValue({ country: loc.country || '' });
          this.onCountryBChange(index); // load states for this country

          // Step 2: Wait a bit to ensure states are loaded, then patch state and trigger cities
          setTimeout(() => {
            branchGroup.patchValue({ state: loc.state || '' });
            this.onStateBChange(index); // load cities for this state

            // Step 3: Patch remaining fields
            branchGroup.patchValue({
              city: loc.city || '',
              lat: loc.lat || '',
              long: loc.long || '',
              pincode: loc.pincode || '',
              officename: loc.officename || '',
              address_line_1: loc.address_line_1 || '',
              address_line_2: loc.address_line_2 || '',
            });
          }, 200); // delay to allow API call for states to finish
        });

        // If empty:
        if (branchFormArray.length === 0) {
          branchFormArray.push(this.createLocationGroup());
        }


        this.getdistricts()
        this.getsubdistricts()
        this.getvillages()



      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  onSubmit(): void {
    if (this.projectId) {
      this.update();
    }
    else {
      if (this.designProjectForm.valid) {
      } else {
        this.designProjectForm.markAllAsTouched();
      }
      const formData = {
        ...this.designProjectForm.value,
        ...this.locationForm.value,
        ...this.clientForm.value

      };


      this.apiService.savelistDesignStages(formData).subscribe({
        next: (res) => {
          this.toastrMsgService.success("Project saved successfully");
          this.router.navigate(["/home/design-stage-list"]);
        },
        error: (err) => {
          this.toastrMsgService.error(err.error.errorMessage);
        },
        complete: () =>'',
      });
    }
  }




  update() {

    const formData = {
      ...this.designProjectForm.value,
      ...this.locationForm.value,
      ...this.clientForm.value

    };
    this.apiService.updateDesignStages(this.projectId, formData).subscribe({
      next: (res) => {
        this.toastrMsgService.success("Project updated successfully");
        this.router.navigate(["/home/design-stage-list"]);
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }


  onCountryBChange(index: number) {
    const branch = this.location.at(index);
    const selectedCountry = branch.get('country')?.value;
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.availableStates[index] = res ? res : []
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });


    // Reset dependent controls
    branch.patchValue({ state: '', city: '' });
  }

  onStateBChange(index: number) {
    const branch = this.location.at(index);
    const selectedCountry = branch.get('country')?.value;
    const selectedState = branch.get('state')?.value;
    this.apiService.getdistricts(selectedState).subscribe({
      next: (res) => {
        this.availableCities[index] = res ? res : [];
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });



    // Reset city control
    branch.patchValue({ city: '' });
  }


  getstates() {
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.allState = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () =>'',
    });
  }

  getdistricts() {
    const state = this.clientForm.value.state;

    this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        this.allDistricts = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }
  getsubdistricts() {

    const state = this.clientForm.value.state;
    const district = this.clientForm.value.district;

    this.apiService.getSubdistricts(state, district).subscribe({
      next: (res) => {
        this.allSubDistricts = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }
  getvillages() {
    const state = this.clientForm.value.state;
    const district = this.clientForm.value.district;
    const subdistrict = this.clientForm.value.subDistrict;
    this.apiService.getvillages(state, district, subdistrict).subscribe({
      next: (res) => {
        this.allVillage = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }


  openPicker(index: number, branch: any) {
    const dialogRef = this.dialog.open(PlacePickerComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        branch.patchValue({
          lat: result.lat,
          long: result.lng
        });
      }
    });
  }

}
